import React from "react";
import { useParams } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import { useState } from "react";
import { apiPath } from "../../utility/Constant";
import { useEffect } from "react";
import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";

function CSRFocusAddPage() {
  const { CSRApi } = apiPath;

  const data = [
    {
      elementType: "textField",
      label: "Focus Title",
      type: "text",
      name: "focusTitle",
    },
    {
      elementType: "textField",
      label: "Focus Description",
      type: "text",
      name: "focusDescription",
    },
  ];

  const update = (data) => {
    data.slug = "focus";
    updateData(`${CSRApi}`, data, null, null, null, true);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
}

export default CSRFocusAddPage;
